import startsWith from 'lodash/startsWith';

import { I18nText } from '../../../../../../../types';
import { IconsEnum } from '../../../../../../../assets/icons/types';
import { PeopleSecondaryMenuItems } from '../../CompactPeopleSecondaryMenu.types';

import { TeamsPermissions } from '../../../../../../teams/teamsConstants';
import { teamsKeys } from '../../../../../../../locales/keys';
import { TeamPath } from '../../../../../../teams/TeamPath';

export const peopleMenuLinks = (permissions: {
  companies: string[];
  performers: string[];
}) => [
  {
    name: PeopleSecondaryMenuItems.COMPANIES,
    href: TeamPath.companiesCompact(),
    i18nText: teamsKeys.companies,
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.companiesCompact()),
    permissions: permissions.companies
  },
  {
    name: PeopleSecondaryMenuItems.PERFORMERS,
    href: TeamPath.performersCompact(),
    i18nText: teamsKeys.performers,
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.performersCompact()),
    permissions: permissions.performers
  }
];

export interface CompactPeopleSecondaryMenuLinksConfigItem {
  action: TeamsPermissions;
  active: boolean;
  count?: number;
  href: string;
  i18nText: I18nText;
  icon: IconsEnum;
  visible?: boolean;
}

export interface CompactPeopleSecondaryMenuLinksConfig {
  companies: CompactPeopleSecondaryMenuLinksConfigItem[];
  performers: CompactPeopleSecondaryMenuLinksConfigItem[];
}
